import type { Thread } from "duck/ui/chat/types";

/**
 * Gets the display title for a thread.
 * Uses the thread's title if available, otherwise uses the fallback string.
 * @param thread - The thread object
 * @param fallbackTitle - The translated fallback title to use when thread.title is null/undefined
 */
export const getThreadTitle = (
  thread: Thread,
  fallbackTitle: string
): string => {
  if (thread.title) {
    return thread.title;
  } else {
    return fallbackTitle;
  }
};

/**
 * Sorts threads by created date in descending order (newest first).
 */
export const sortThreadsByDate = (threads: Thread[] | null): Thread[] => {
  if (!threads) {
    return [];
  }

  return threads.toSorted(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
};

/**
 * Filters threads by search query (case-insensitive search on thread title).
 * @param threads - Array of threads to filter
 * @param searchQuery - Search query string
 * @param emptyThreadTitle - The translated fallback title for threads without a title
 */
export const filterThreadsBySearch = (
  threads: Thread[],
  searchQuery: string,
  emptyThreadTitle: string
): Thread[] => {
  if (!searchQuery) {
    return threads;
  }

  const query = searchQuery.toLowerCase();

  return threads.filter((thread) =>
    getThreadTitle(thread, emptyThreadTitle).toLowerCase().includes(query)
  );
};
